import { myUploadsParamType } from '../_helpers/coachHelpers/query';
import { apiHeader } from '../constants/apiHeader';
import { PackagePayloadInterface } from '../interfaces/coachInterfaces/packageInterface';
import {
  deleteApi,
  get,
  post,
  postImageFileWithToken,
  put,
} from './apiService';

export const createPackageApi = async (data: PackagePayloadInterface) => {
  return await post('/packages', data, apiHeader.APPLICATION_JSON);
};
export const editPackageApi = async (
  data: PackagePayloadInterface,
  id: string
) => {
  return await put('/packages/' + id, data, apiHeader.APPLICATION_JSON);
};
export const ImageUploadPackage = async (payload: any) => {
  return await postImageFileWithToken('/files', payload);
};
export const getAssessments = async (
  id: string,
  params?: myUploadsParamType
) => {
  return await get(
    '/assessments?activityStatus=LIVE&requestStatusFilter=APPROVED&coachId=' +
      id,
    params
  );
};
export const getSession = async (id: string, params?: myUploadsParamType) => {
  return await get(
    '/sessions?activityStatus=LIVE&requestStatusFilter=APPROVED&coachId=' + id,
    params
  );
};
export const getAssessmentsById = async (
  id: string,
  params?: myUploadsParamType
) => {
  return await get('/assessments/' + id, params);
};
export const getSessionById = async (
  id: string,
  params?: myUploadsParamType
) => {
  return await get('/sessions/' + id, params);
};
export const getPackage = async (id: string, params?: myUploadsParamType) => {
  return await get(
    '/packages?activityStatus=LIVE&requestStatusFilter=APPROVED&coachId=' + id,
    params
  );
};
export const savePackageApi = async (data: {
  draftType: string;
  request: PackagePayloadInterface;
}) => {
  return await post('/coach-service-draft', data, apiHeader.APPLICATION_JSON);
};
export const saveDraftPackageApi = async (
  data: {
    draftType: string;
    request: PackagePayloadInterface;
  },
  id: string
) => {
  return await put(
    '/coach-service-draft/' + id,
    data,
    apiHeader.APPLICATION_JSON
  );
};
export const deletePackageApi = async (id: string) => {
  return await deleteApi('/packages/' + id, apiHeader.APPLICATION_JSON);
};
export const deleteAssessmentApi = async (id: string) => {
  return await deleteApi('/assessments/' + id, apiHeader.APPLICATION_JSON);
};
export const deleteSessionApi = async (id: string) => {
  return await deleteApi('/sessions/' + id, apiHeader.APPLICATION_JSON);
};
export const listDurationApi = async () => {
  return await get('/lists?name=PACKAGE_DURATION');
};
export const packageById = async (id: string) => {
  return await get('/packages/' + id);
};
export const assessmentById = async (id: string) => {
  return await get('/assessments/' + id);
};
export const sessionById = async (id: string) => {
  return await get('/sessions/' + id);
};
